import { TPersonalDataApplicationsStore } from '~/store/processing-personal/types.ts';
import { SerializedError } from '@reduxjs/toolkit';
import { TErrorResponse } from '~/store/types.ts';
import { errorMessages } from '~/constants/errorMessages.ts';

export const personalDataApplicationsError = (
  state: TPersonalDataApplicationsStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  state.loading = false;

  if (action.error.name === 'AbortError') {
    state.error = null;
  } else {
    state.error = (action.payload as TErrorResponse)?.message || errorMessages.SERVICE_UNAVAILABLE;
  }
};
